import "./Home.module.css";
import GlobalNavigation from "@/reusable_sections/Header";
import GlobalLogisticsExcellence from "./sections/GlobalLogisticsExcellence";
import IndustrialLogisticsLeaders from "./sections/IndustrialLogisticsLeaders";
import CoreMaritimeCapabilities from "./sections/CoreMaritimeCapabilities";
import StrategicPortPresence from "./sections/StrategicPortPresence";
import IndustryTrustFactors from "./sections/IndustryTrustFactors";
import RequestSupplyQuote from "./sections/RequestSupplyQuote";
import SupplyCategories from "./sections/SupplyCategories";
import HowOurCoordinationWorks from "./sections/HowOurCoordinationWorks";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <GlobalNavigation />
      <GlobalLogisticsExcellence />
      <IndustrialLogisticsLeaders />
      <CoreMaritimeCapabilities />
      <StrategicPortPresence />
      <IndustryTrustFactors />
      <SupplyCategories />
      <HowOurCoordinationWorks />
      <RequestSupplyQuote />
      <Footer />
    </div>;
}